import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "doc-updated"
}
const _hoisted_2 = { class: "doc-meta" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "doc-changelog"
}
const _hoisted_5 = { class: "muted" }
const _hoisted_6 = {
  key: 0,
  class: "doc-toc"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "doc-content",
    ref: "root",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    (_ctx.updatedNote)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("b", null, "Guide updated (v" + _toDisplayString(_ctx.doc.version) + "):", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.updatedNote), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" v" + _toDisplayString(_ctx.doc.version) + " · updated " + _toDisplayString(_ctx.doc.updated_at) + " ", 1),
      (_ctx.offline)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " · offline copy"))
        : _createCommentVNode("", true),
      _cache[2] || (_cache[2] = _createTextVNode(" · ", -1)),
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showChangelog = !_ctx.showChangelog), ["prevent"]))
      }, _toDisplayString(_ctx.showChangelog ? 'Back to guide' : 'Change log'), 1)
    ]),
    (_ctx.showChangelog)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doc.changelog, (entry) => {
            return (_openBlock(), _createElementBlock("li", {
              key: entry.version
            }, [
              _createElementVNode("b", null, "v" + _toDisplayString(entry.version), 1),
              _createTextVNode(" " + _toDisplayString(entry.change_summary) + " ", 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(entry.date), 1)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.doc.toc && _ctx.doc.toc.length > 3)
            ? (_openBlock(), _createElementBlock("details", _hoisted_6, [
                _cache[3] || (_cache[3] = _createElementVNode("summary", null, "On this page", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doc.toc, (item) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: item.id,
                    href: '#' + item.id,
                    class: _normalizeClass('toc-l' + item.level)
                  }, _toDisplayString(item.text), 11, _hoisted_7))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "doc-body",
            innerHTML: _ctx.doc.html
          }, null, 8, _hoisted_8)
        ], 64))
  ], 512))
}